import { Suspense, lazy } from 'react';

import { createFileRoute } from '@tanstack/react-router';

const MyWorkPage = lazy(() =>
  import('@/features/my-work/pages/MyWorkPage').then((m) => ({ default: m.MyWorkPage })),
);

function MyWorkPageWrapper() {
  return (
    <Suspense fallback={<div className="p-8 text-center text-quiet">Cargando tu trabajo...</div>}>
      <MyWorkPage />
    </Suspense>
  );
}

export const Route = createFileRoute('/_app/$wsSlug/my-work')({
  component: MyWorkPageWrapper,
});
